import { withLandingFilterStore } from '@doltech/ui/lib/figma/LandingFilterV2/withLandingFilterStore';
import { compose } from '@doltech/utils/lib/compose';
import { SpeakingSampleTypeEnum, WritingSampleTypeEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';

import {
  DEFAULT_WRITING_TASK_1_LANDING_FILTER,
  DEFAULT_WRITING_TASK_2_ACADEMIC_LANDING_FILTER,
  DEFAULT_WRITING_TASK_2_GENERAL_LANDING_FILTER,
  getSpeakingLandingFilter,
} from '../../constants';
import { WritingSampleCard } from '../components/WritingSampleCard';
import {
  SampleTypeLandingTemplate,
  SampleTypeLandingTemplateProps,
} from '../templates/SampleTypeLandingTemplate';

interface WritingSampleTaskLandingContentProps extends SampleTypeLandingTemplateProps {}

const WritingSampleTaskLandingContent = (props: WritingSampleTaskLandingContentProps) => {
  return (
    <SampleTypeLandingTemplate
      renderCard={(cardData) => <WritingSampleCard data={cardData} directional="horizontal" />}
      {...props}
    />
  );
};

const withSampleFilter = (Component) => (props) => {
  const { pageData } = props;
  const { type } = pageData || {};
  switch (type) {
    case WritingSampleTypeEnum.WRITING_TASK_1: {
      return withLandingFilterStore(DEFAULT_WRITING_TASK_1_LANDING_FILTER)(Component)(props);
    }
    case WritingSampleTypeEnum.WRITING_TASK_2_ACADEMIC: {
      return withLandingFilterStore(DEFAULT_WRITING_TASK_2_ACADEMIC_LANDING_FILTER, {
        syncUrl: false,
      })(Component)(props);
    }
    case WritingSampleTypeEnum.WRITING_TASK_1_GENERAL: {
      return withLandingFilterStore(DEFAULT_WRITING_TASK_2_GENERAL_LANDING_FILTER, {
        syncUrl: false,
      })(Component)(props);
    }
    case SpeakingSampleTypeEnum.SPEAKING_PART_1:
    case SpeakingSampleTypeEnum.SPEAKING_PART_2:
    case SpeakingSampleTypeEnum.SPEAKING_PART_3: {
      return withLandingFilterStore(getSpeakingLandingFilter(type), {
        syncUrl: false,
      })(Component)(props);
    }
  }
  return <Component {...props} />;
};

export const WritingSampleTaskLanding: React.FunctionComponent<WritingSampleTaskLandingContentProps> =
  compose(withSampleFilter)(WritingSampleTaskLandingContent);
